module.exports = __webpack_public_path__ + "img/pr-11.41350fed.png";